<ng-container *ngIf="chartData">
  <eds-proximal [placement]="chartData.proximalPlacementTop"></eds-proximal>

  <highcharts-chart
    *ngIf="highcharts"
    [Highcharts]="highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 400px; display: block"
  ></highcharts-chart>

  <eds-proximal [placement]="chartData.proximalPlacementBottom"></eds-proximal>
</ng-container>
